/**
 * Ruscha tarjimalar.
 *
 * Kalit — OʻZBEKCHA matnning oʻzi (qarang `i18n/index.ts`). Bu yerda
 * yoʻq satr oʻzbekcha holida chiqadi, yaʼni yarim tarjima qilingan
 * ilova ham ishlaydi.
 *
 * Koʻplik: qiymat massiv boʻlsa `[1, 2–4, 5+]` tartibida —
 * «1 урок», «2 урока», «5 уроков».
 *
 * TARJIMA QOIDASI: oʻqituvchi yozgan MAZMUN (dars nomi, konspekt,
 * savol matni) tarjima QILINMAYDI — u markazning oʻz tilida qoladi.
 * Bu yerda faqat ilovaning oʻz matnlari.
 */
export const ru: Record<string, string | string[]> = {
  // ——— Pastki menyu ———
  Darslar: 'Уроки',
  Guruhlar: 'Группы',
  Natijalar: 'Результаты',
  'Asosiy menyu': 'Главное меню',
  Reyting: 'Рейтинг',
  Yordam: 'Помощь',
  Profil: 'Профиль',

  // ——— Umumiy holatlar ———
  'Qayta urinish': 'Повторить',
  Yopish: 'Закрыть',
  Bekor: 'Отмена',
  Saqlash: 'Сохранить',
  'Saqlanmoqda…': 'Сохранение…',
  'Saqlandi.': 'Сохранено.',
  'Saqlab boʻlmadi.': 'Не удалось сохранить.',
  'Yuklab boʻlmadi': 'Не удалось загрузить',
  'Saqlab boʻlmadi': 'Не удалось сохранить',
  'Dars qadamlari': 'Шаги урока',
  'Bu qism tugallangan': 'Эта часть завершена',
  'Materialni koʻrib chiqdingizmi? Davom eting.':
    'Изучили материал? Продолжайте.',
  'Tushundim, davom etish': 'Понятно, продолжить',
  Qadam: 'Шаг',
  'Yangi qadam': 'Новый шаг',
  'Qadamni tahrirlash': 'Редактировать шаг',
  'Qadamni oʻchirish': 'Удалить шаг',
  'Qadam nomi': 'Название шага',
  'Qadam qoʻshildi.': 'Шаг добавлен.',
  '"{title}" qadami oʻchirilsinmi?': 'Удалить шаг «{title}»?',
  'Dars qadamlarga boʻlinsinmi?': 'Разделить урок на шаги?',
  'Darsning hozirgi videosi, matni va nazorati 1-qadamga koʻchadi, yangi qadam undan keyin keladi. Oʻquvchilarning natijalari saqlanadi.':
    'Текущие видео, текст и контроль урока станут шагом 1, новый шаг пойдёт после него. Результаты учеников сохранятся.',
  'Muddat va modul nazorati darsdan olinadi.':
    'Срок и итоговый контроль модуля берутся из урока.',
  'Hamma qadamlar shu muddatda tugatilsin. 0 — muddatsiz.':
    'Все шаги нужно пройти за этот срок. 0 — без срока.',
  'Bu dars {count} qadamdan iborat (video, nazorat). Qadamlarni roʻyxatda, dars ostida tahrirlaysiz.':
    [
      'Урок состоит из {count} шага (видео, контроль). Шаги редактируются в списке, под уроком.',
      'Урок состоит из {count} шагов (видео, контроль). Шаги редактируются в списке, под уроком.',
      'Урок состоит из {count} шагов (видео, контроль). Шаги редактируются в списке, под уроком.',
    ],
  '{count} qadam': ['{count} шаг', '{count} шага', '{count} шагов'],
  'Keyingi qadam: {title}': 'Следующий шаг: {title}',
  'Keyingi qadam ochildi.': 'Следующий шаг открыт.',
  'Bu qadamning testidan oʻtgansiz.': 'Вы прошли тест этого шага.',
  '{done} / {count} qadam bajarildi': 'Выполнено шагов: {done} / {count}',
  Orqaga: 'Назад',

  // ——— Kurs roʻyxati ———
  'Kurs progressi': 'Прогресс курса',
  'Darslar hali qoʻshilmagan': 'Уроки ещё не добавлены',
  'Ustozingiz dars qoʻshgach, ular shu yerda paydo boʻladi.':
    'Когда преподаватель добавит уроки, они появятся здесь.',
  'Maʼlumotlar topilmadi': 'Данные не найдены',
  'Ulanib boʻlmadi': 'Не удалось подключиться',
  'Arizangiz koʻrib chiqilmoqda': 'Ваша заявка рассматривается',
  'Muddati oʻtgan': 'Просрочено',
  'Dars materiali': 'Материал урока',
  'Ochib boʻlmadi.': 'Не удалось открыть.',
  'Bu darsning muddati oʻtgan. Ustozingizga murojaat qiling.':
    'Срок этого урока истёк. Обратитесь к преподавателю.',

  // ——— Dars ———
  'Video koʻrildi': 'Видео просмотрено',
  'Audio rejim': 'Аудиорежим',
  Konspekt: 'Конспект',
  Yakunlandi: 'Завершено',
  'Bu darsni hozir faqat siz koʻryapsiz': 'Сейчас этот урок смотрите только вы',
  Ochish: 'Открыть',
  'PDF yoki hujjat': 'PDF или документ',
  'Video shu yerda ochilmadi. Telegram ichidagi brauzer uni koʻrsatmayotgan boʻlishi mumkin.':
    'Видео не открылось здесь. Возможно, встроенный браузер Telegram его не показывает.',
  'Videoni brauzerda ochish': 'Открыть видео в браузере',

  // ——— Koʻplik namunasi ———
  '{count} dars': ['{count} урок', '{count} урока', '{count} уроков'],
  '{count} savol': ['{count} вопрос', '{count} вопроса', '{count} вопросов'],

  // ——— Saytdan kirish ———
  'Darslaringizga kirish uchun Telegram hisobingiz bilan kiring.':
    'Войдите через Telegram, чтобы открыть свои уроки.',
  'Yuqoridagi tugma ishlamasa:': 'Если кнопка выше не работает:',
  'Botdan kirish havolasini olish': 'Получить ссылку для входа у бота',

  // ——— Profil ———
  Oʻzlashtirish: 'Успеваемость',
  '{a} / {b} dars': '{a} / {b} уроков',
  XP: 'XP',
  Tanga: 'Монеты',
  Kun: 'Дней',
  Sana: 'Дата',
  'Sertifikat ID': 'ID сертификата',
  Berildi: 'Выдан',
  'Guruh biriktirilmagan': 'Группа не назначена',

  // ——— Dars roʻyxati ———
  'Urinilmoqda…': 'Попытка…',
  'Guruh tanlanmagan': 'Группа не выбрана',
  'Darsni ochish': 'Открыть урок',
  'Avvalgi darsni yakunlang': 'Завершите предыдущий урок',
  'Avvalgi darsni yakunlang.': 'Завершите предыдущий урок.',

  // ——— Reyting ———
  'Guruh tanlang va oʻquvchilar natijalarini koʻring.':
    'Выберите группу, чтобы увидеть результаты учеников.',
  'Darslarni yakunlab va testlardan yuqori ball olib yuqoriga koʻtariling.':
    'Завершайте уроки и набирайте баллы, чтобы подняться выше.',
  'Reytingni koʻrish uchun yuqoridan guruhni tanlang.':
    'Выберите группу сверху, чтобы увидеть рейтинг.',
  'Reyting yuklanmadi': 'Рейтинг не загрузился',
  'Internetni tekshirib, qaytadan urinib koʻring.':
    'Проверьте интернет и попробуйте снова.',
  'Reyting hali boʻsh': 'Рейтинг пока пуст',
  'Bu guruhda hali hech kim darsni boshlamagan.':
    'В этой группе ещё никто не начал урок.',
  'Guruhda hali hech kim dars yakunlamagan. Birinchi boʻling.':
    'В группе ещё никто не завершил урок. Будьте первым.',

  // ——— Dars ekrani ———
  'Audio rejim — ekran oʻchirilgan, ovoz davom etadi':
    'Аудиорежим — экран выключен, звук продолжается',
  'Faqat sizga koʻrinadi va saqlanib qoladi.':
    'Видно только вам и сохраняется.',

  // ——— Test ———
  'Natijani saqlab boʻlmadi. Qaytadan urining.':
    'Не удалось сохранить результат. Попробуйте снова.',
  'Bu darsda test yoʻq': 'В этом уроке нет теста',
  'Dars materialini oʻqib chiqing — keyingi dars avtomatik ochiladi.':
    'Прочитайте материал урока — следующий откроется автоматически.',
  Oʻtilgan: 'Пройдено',
  'Test topshirilgan': 'Тест сдан',
  'Darslarga qaytish': 'Вернуться к урокам',
  'Sotib olib boʻlmadi.': 'Не удалось купить.',
  'Urinishlar soni tugagan.': 'Попытки закончились.',
  'Testni boshlab boʻlmadi.': 'Не удалось начать тест.',
  'Nazorat testi': 'Контрольный тест',
  Savollar: 'Вопросы',
  Urinishlar: 'Попытки',
  Vaqt: 'Время',
  'Testni boshlash': 'Начать тест',
  'Test tahlili': 'Разбор теста',
  Toʻgʻri: 'Верно',
  'Natijaga qaytish': 'Вернуться к результату',
  Oʻtdingiz: 'Сдано',
  'Oʻta olmadingiz': 'Не сдано',
  Natijangiz: 'Ваш результат',
  'Kerak edi': 'Требовалось',
  'Keyingi dars ochildi.': 'Следующий урок открыт.',
  'Xatolarni koʻrib chiqing va qayta urinib koʻring.':
    'Разберите ошибки и попробуйте снова.',
  'Natijani yaxshilash': 'Улучшить результат',
  'Qaytadan urinish': 'Попробовать снова',
  'Xatolarni koʻrish': 'Посмотреть ошибки',
  'Tahlil videosi': 'Видео с разбором',
  'Natijani koʻrish': 'Посмотреть результат',
  'Barcha savollarga javob bering.': 'Ответьте на все вопросы.',

  // ——— AI yordamchi ———
  'Salom! Kurs va darslar boʻyicha savolingiz boʻlsa, shu yerda soʻrang.':
    'Здравствуйте! Задайте здесь любой вопрос по курсу и урокам.',
  'Javob olib boʻlmadi. Ustozingiz AI yordamchisini yoqmagan boʻlishi mumkin.':
    'Не удалось получить ответ. Возможно, преподаватель не включил AI-помощника.',
  Oʻylamoqda: 'Думает',
  Savolingiz: 'Ваш вопрос',
  'Modul materiallari oʻqib chiqilmoqda. Bu bir necha soniya oladi.':
    'Читаю материалы модуля. Это займёт несколько секунд.',
  'Xulosani tayyorlab boʻlmadi. Qaytadan urinib koʻring.':
    'Не удалось подготовить обзор. Попробуйте снова.',

  // ——— Kurs tanlash ———
  'Qaysi kursni ochamiz?': 'Какой курс открыть?',
  'Kurs topilmadi': 'Курс не найден',
  'Ustozingizdan taklif havolasini soʻrang.':
    'Попросите у преподавателя пригласительную ссылку.',

  // ——— Faylli topshiriq ———
  'Ball qoʻyilgach Telegramga xabar keladi.':
    'Когда оценку поставят, придёт уведомление в Telegram.',
  'Natija darhol chiqadi.': 'Результат появится сразу.',
  'Fayl juda katta. Eng koʻpi 20 MB.': 'Файл слишком большой. Максимум 20 МБ.',
  'Javobingizni kiriting.': 'Введите свой ответ.',
  'Javob matnini yozing yoki fayl biriktiring.':
    'Напишите ответ или прикрепите файл.',
  'Yuborib boʻlmadi.': 'Не удалось отправить.',
  'Qayta ochib boʻlmadi.': 'Не удалось открыть заново.',
  'Fayl formati nomaʼlum': 'Формат файла неизвестен',
  'Topshiriq fayli yuklanmagan.': 'Файл задания не загружен.',
  'Urinishlar tugagan. Ustozingizga murojaat qiling.':
    'Попытки закончились. Обратитесь к преподавателю.',
  Javobingiz: 'Ваш ответ',
  'Javobingizni batafsil yozing': 'Напишите ответ подробно',
  'Fayl biriktirish — PDF yoki rasm, 20 MB gacha':
    'Прикрепить файл — PDF или изображение, до 20 МБ',
  'Faylni olib tashlash': 'Убрать файл',
  'Javobni yuborish': 'Отправить ответ',
  'Yuborilgan javob': 'Отправленный ответ',
  'Yuborilgan faylni ochish': 'Открыть отправленный файл',
  'Ustoz shu darsning yechimini tushuntirgan.':
    'Преподаватель объяснил решение этого урока.',

  // ——— Material ———
  'Bu formatni bu yerda ochib boʻlmaydi': 'Этот формат здесь не открывается',
  'Faylni ochish': 'Открыть файл',

  Dars: 'Урок',

  // ═══════════════════════════════════════════════════════════════
  // USTOZ REJIMI
  //
  // Ustozlar odatda oʻzbek tilida ishlaydi, lekin rus tilida
  // soʻzlashadigan markazning oʻqituvchisi ham boʻlishi mumkin —
  // shuning uchun bu yerda ham toʻliq tarjima bor.
  // ═══════════════════════════════════════════════════════════════

  // ——— Ustoz paneli ———
  'Maʼlumotni yuklab boʻlmadi.': 'Не удалось загрузить данные.',
  'Avval kurs yarating.': 'Сначала создайте курс.',
  'Guruh yaratildi.': 'Группа создана.',
  'Guruh yaratib boʻlmadi.': 'Не удалось создать группу.',
  'Ustoz rejimi ochilmadi': 'Режим преподавателя не открылся',
  'Botda /start bosing — ustoz sifatida kiring.':
    'Нажмите /start в боте — войдите как преподаватель.',
  Kurslar: 'Курсы',
  Topshiriqlar: 'Задания',
  'Guruh yoʻq': 'Групп нет',
  'Avval kurs yarating — guruh kursga biriktiriladi.':
    'Сначала создайте курс — группа привязывается к курсу.',
  'Guruh yarating va taklif havolasini yuboring.':
    'Создайте группу и отправьте пригласительную ссылку.',
  'Guruh yaratish': 'Создать группу',
  'Guruh qoʻshish': 'Добавить группу',
  Oʻrtacha: 'Средний',

  // ——— Oʻquvchi qoʻshish ———
  'Ism-familiyani kiriting.': 'Введите имя и фамилию.',
  'Telefon raqamini kiriting.': 'Введите номер телефона.',
  'Oʻquvchi qoʻshildi.': 'Ученик добавлен.',
  'Oʻquvchini qoʻshib boʻlmadi.': 'Не удалось добавить ученика.',
  'Oʻquvchi qoʻshish': 'Добавить ученика',
  'Ism-familiya': 'Имя и фамилия',
  Telefon: 'Телефон',
  'Bot oʻquvchini shu raqam boʻyicha taniydi.':
    'Бот узнаёт ученика по этому номеру.',
  'Qoʻshilmoqda…': 'Добавление…',
  Qoʻshish: 'Добавить',

  // ——— Eʼlon ———
  '{count} oʻquvchiga yuborilmoqda.': [
    'Отправляется {count} ученику.',
    'Отправляется {count} ученикам.',
    'Отправляется {count} ученикам.',
  ],
  Kimga: 'Кому',
  'Yuborildi. Ustoz javobi botga keladi.':
    'Отправлено. Ответ преподавателя придёт в бот.',
  'Ustozga savol': 'Вопрос преподавателю',
  'Savolingizni yozing — ustozingiz javobi botga keladi.':
    'Напишите вопрос — ответ преподавателя придёт в бот.',
  Rasm: 'Фото',
  'Savolingiz…': 'Ваш вопрос…',
  'Rasm tanlandi': 'Фото выбрано',
  'Rasmni olib tashlash': 'Убрать фото',
  'Tushunmagan joyingiz bormi?': 'Что-то непонятно?',
  'Ustozga yozing — javobi botga keladi.':
    'Напишите преподавателю — ответ придёт в бот.',
  'Oylik toʻlov eslatmasi': 'Ежемесячное напоминание об оплате',
  'Har oy {day}-kuni {time}, {until} gacha':
    'Каждый месяц {day}-го в {time}, до {until}',
  'Sozlanmagan — admin panelda sozlanadi.':
    'Не настроено — настраивается в админ-панели.',
  'Ixtiyoriy — xohlasangiz ishlang': 'Необязательный — по желанию',
  Ixtiyoriy: 'Необязательный',
  'Qaysi darsdan boshlagan': 'С какого урока начал',
  'Birinchi darsdan': 'С первого урока',
  'Butun guruh ({count})': 'Вся группа ({count})',
  Tanlanganlar: 'Выбранные',
  Qarzdorlar: 'Должники',
  Tozalash: 'Очистить',
  'Telegram yoʻq': 'Нет Telegram',
  tanlanganlarga: 'выбранным',
  'Birinchi {shown} ta oʻquvchi koʻrsatildi (jami {total}). Qolganlari — admin panelda.':
    'Показаны первые {shown} учеников (всего {total}). Остальные — в админ-панели.',
  'Eʼlonni yuborib boʻlmadi.': 'Не удалось отправить объявление.',
  'Eʼlon yuborish': 'Отправка объявления',
  Eʼlon: 'Объявление',
  'Oʻquvchilarga nima demoqchisiz?': 'Что хотите сказать ученикам?',
  Yuborish: 'Отправить',
  'Yuborilmoqda…': 'Отправка…',
  'Ha, yuborilsin': 'Да, отправить',
  'Oldingi eʼlonlar': 'Прошлые объявления',

  // ——— Kurs sozlamalari ———
  'Dars oʻtish chegarasi 1–100 orasida boʻlsin.':
    'Порог прохождения урока должен быть от 1 до 100.',
  'Kurs yaratildi.': 'Курс создан.',
  'Kurs sozlamalari': 'Настройки курса',
  'Yangi kurs': 'Новый курс',
  Tavsif: 'Описание',
  'Kurs qanday sotiladi': 'Как продаётся курс',
  'Toʻlamaganlar bloklansin': 'Блокировать неоплативших',
  'Necha kun kutiladi': 'Сколько дней ждать',
  'Dars oʻtish chegarasi, %': 'Порог прохождения урока, %',
  'Modul oʻtish chegarasi, %': 'Порог прохождения модуля, %',
  'Toʻliq natija uchun XP': 'XP за полный результат',
  'Tanga tizimi yoqilsin': 'Включить систему монет',
  'Oʻquvchi toʻplagan tangaga qoʻshimcha imkoniyat sotib oladi.':
    'Ученик покупает дополнительные возможности за накопленные монеты.',
  'Qoʻshimcha urinish narxi': 'Цена дополнительной попытки',
  'Darsni qayta ochish narxi': 'Цена повторного открытия урока',
  'Darsni oʻtkazib yuborish narxi': 'Цена пропуска урока',
  'Kursga kirish muddati, kun': 'Срок доступа к курсу, дней',
  'Faolsizlik: ogohlantirish, kun': 'Неактивность: предупреждение, дней',
  'Faolsizlik: bloklash, kun': 'Неактивность: блокировка, дней',

  // ——— Reyting (ustoz) ———
  'Reytingni yuklab boʻlmadi.': 'Не удалось загрузить рейтинг.',
  'Oʻquvchilar darslarni boshlagach shu yerda koʻrinadi.':
    'Появится здесь, когда ученики начнут уроки.',

  // ——— Dars tahrirlash ———
  'Video tayyor.': 'Видео готово.',
  'Videoni qayta ishlab boʻlmadi. Qayta yuklang.':
    'Не удалось обработать видео. Загрузите снова.',
  'Yuklandi.': 'Загружено.',
  'Yuklab boʻlmadi.': 'Не удалось загрузить.',
  'Havola yoki yuklang': 'Ссылка или загрузите',
  'Dars nomini kiriting.': 'Введите название урока.',
  'Faylli nazorat uchun topshiriq fayli kerak.':
    'Для файлового задания нужен файл с заданием.',
  'Avtomat tekshirish uchun javob kaliti kerak.':
    'Для автопроверки нужен ключ ответов.',
  'Dars qoʻshildi.': 'Урок добавлен.',
  'Darsni tahrirlash': 'Редактировать урок',
  'Yangi dars': 'Новый урок',
  'Dars nomi': 'Название урока',
  'Oʻquvchi video ostida shuni oʻqiydi.': 'Ученик читает это под видео.',
  'Testdan oldin videoni koʻrish shart':
    'Просмотр видео обязателен перед тестом',
  'Modul yakuniy nazorati': 'Итоговый тест модуля',
  'Kursning modul oʻtish chegarasi qoʻllanadi.':
    'Применяется порог прохождения модуля.',
  'Nazorat turi': 'Тип контроля',
  'Test savollari': 'Тестовые вопросы',
  'Faylli topshiriq': 'Файловое задание',
  'Kim tekshiradi': 'Кто проверяет',
  'Ustoz qoʻlda': 'Преподаватель вручную',
  'Javob kaliti boʻyicha': 'По ключу ответов',
  'Javob kaliti': 'Ключ ответов',
  'Namunaviy javob': 'Образец ответа',
  'Toʻgʻri javob qanday boʻlishi kerak?': 'Каким должен быть верный ответ?',
  'Baholash mezoni': 'Критерии оценки',
  'Nimaga qancha ball berilishini yozing. Ixtiyoriy.':
    'Напишите, за что сколько баллов. Необязательно.',
  'Urinishlar soni': 'Количество попыток',

  // ——— Baholash ———
  'Topshiriqlarni yuklab boʻlmadi.': 'Не удалось загрузить задания.',
  'Ball 0 va 100 oraligʻida boʻlsin.': 'Балл должен быть от 0 до 100.',
  'Baholandi.': 'Оценено.',
  'Baholab boʻlmadi.': 'Не удалось оценить.',
  'Navbat boʻsh': 'Очередь пуста',
  'Baholangan ish yoʻq': 'Оценённых работ нет',
  'Hamma topshiriq koʻrib chiqilgan.': 'Все задания проверены.',
  'Baholangan ishlar shu yerda koʻrinadi.': 'Оценённые работы появятся здесь.',
  'Oʻquvchi javobi': 'Ответ ученика',
  Izoh: 'Комментарий',
  'Oʻquvchiga nima deysiz?': 'Что скажете ученику?',
  Baholash: 'Оценить',

  // ——— Toʻlovlar ———
  Toʻlangan: 'Оплачено',
  Kutilmoqda: 'Ожидается',
  'Bekor qilingan': 'Отменено',
  'Toʻlovlarni yuklab boʻlmadi.': 'Не удалось загрузить платежи.',
  'Summani kiriting.': 'Введите сумму.',
  'Toʻlov qayd qilindi.': 'Платёж записан.',
  'Toʻlovni qayd qilib boʻlmadi.': 'Не удалось записать платёж.',
  'Toʻlov oʻchirilsinmi?': 'Удалить платёж?',
  Oʻchirish: 'Удалить',
  'Oʻchirildi.': 'Удалено.',
  'Oʻchirib boʻlmadi.': 'Не удалось удалить.',
  Toʻlovlar: 'Платежи',
  'Sentabr oyi uchun': 'За сентябрь',
  'Toʻlangan deb belgilansin': 'Отметить как оплаченный',
  'Toʻlov qayd qilinmagan.': 'Платежи не записаны.',
  'Toʻlovni oʻchirish': 'Удалить платёж',

  // ——— Oʻquvchi ———
  Ochilmagan: 'Не открыт',
  'Ismni kiriting.': 'Введите имя.',
  'Oʻquvchi oʻchirilsinmi?': 'Удалить ученика?',
  'Qoʻshimcha urinish berilsinmi?': 'Дать дополнительную попытку?',
  'Qoʻshimcha urinish berildi.': 'Дополнительная попытка выдана.',
  'Berib boʻlmadi.': 'Не удалось выдать.',
  'Oʻquvchi darslari': 'Уроки ученика',
  Oʻquvchi: 'Ученик',
  Yuklanmadi: 'Не загрузилось',
  'Oʻrtacha ball': 'Средний балл',
  'Berilmoqda…': 'Выдаётся…',
  Maʼlumotlari: 'Данные',
  Tahrirlash: 'Редактировать',

  // ——— Kurslar (ustoz) ———
  'Kurslarni yuklab boʻlmadi.': 'Не удалось загрузить курсы.',
  'Modul qoʻshildi.': 'Модуль добавлен.',
  'Qoʻshib boʻlmadi.': 'Не удалось добавить.',
  'Buni qaytarib boʻlmaydi.': 'Это нельзя отменить.',
  'Kurs yoʻq': 'Курсов нет',
  'Birinchi kursni yarating, soʻng modul va darslar qoʻshing.':
    'Создайте первый курс, затем добавьте модули и уроки.',
  'Kursni oʻchirish': 'Удалить курс',
  'Modul yoʻq. Darslar modul ichida turadi.':
    'Модулей нет. Уроки находятся внутри модуля.',
  'Modul nomini oʻzgartirish': 'Переименовать модуль',
  'Modulni oʻchirish': 'Удалить модуль',
  Video: 'Видео',
  Fayl: 'Файл',
  'Darsni oʻchirish': 'Удалить урок',
  'Dars qoʻshish': 'Добавить урок',
  'Modul qoʻshish': 'Добавить модуль',

  // ——— Guruh ———
  Faol: 'Активен',
  Tasdiqlanmagan: 'Не подтверждён',
  Bloklangan: 'Заблокирован',
  Kirmagan: 'Не заходил',
  Bugun: 'Сегодня',
  Kecha: 'Вчера',
  'Guruhni yuklab boʻlmadi.': 'Не удалось загрузить группу.',
  'Bloklandi.': 'Заблокирован.',
  'Faollashtirildi.': 'Активирован.',
  'Holatni oʻzgartirib boʻlmadi.': 'Не удалось изменить статус.',
  'Havola nusxalandi.': 'Ссылка скопирована.',
  'Nusxalab boʻlmadi.': 'Не удалось скопировать.',
  'Guruh topilmadi': 'Группа не найдена',
  Hammasi: 'Все',
  Qarzdor: 'Должник',
  'Taklif havolasini nusxalash': 'Скопировать пригласительную ссылку',
  'Oʻquvchi qidirish': 'Поиск ученика',
  'Oʻquvchi yoʻq': 'Учеников нет',
  'Bu saralashda hech kim yoʻq': 'В этом фильтре никого нет',
  'Darslari va urinishlari': 'Уроки и попытки',

  // ——— Savollar ———
  'Avval darsga konspekt yozing — AI shundan savol yasaydi.':
    'Сначала напишите конспект урока — AI составит вопросы по нему.',
  'AI savol qaytarmadi. Qayta urinib koʻring.':
    'AI не вернул вопросы. Попробуйте снова.',
  'AI savol yasay olmadi.': 'AI не смог составить вопросы.',
  'Savollarni yuklab boʻlmadi.': 'Не удалось загрузить вопросы.',
  'Savol oʻchirilsinmi?': 'Удалить вопрос?',
  'Savollar saqlandi.': 'Вопросы сохранены.',
  'Savol yoʻq': 'Вопросов нет',
  'Pastdagi tugma bilan qoʻshing.': 'Добавьте кнопкой ниже.',
  'Savol qoʻshish': 'Добавить вопрос',
  'AI yozmoqda…': 'AI пишет…',
  'AI bilan savol yasash': 'Составить вопросы с AI',

  // ——— Sayt sarlavhasi ———
  'Davom etish': 'Продолжить',
  'Hamma dars yakunlandi': 'Все уроки завершены',
  'Sertifikatingiz profilda.': 'Ваш сертификат в профиле.',

  // ——— Til tanlash ———
  Til: 'Язык',
  Sertifikatlar: 'Сертификаты',
  Oʻzbekcha: 'Узбекский',
  Ruscha: 'Русский',

  // ——— Komponentlar ———
  'AI javob yozmoqda': 'AI пишет ответ',
  'Dars videosi': 'Видео урока',
  'Bekor qilish': 'Отмена',
  'Oʻqituvchi rejimi': 'Режим преподавателя',
  '{coins} tanga, {streak} kunlik ketma-ketlik':
    'Монеты: {coins}, серия: {streak} дн.',
  '{streak} kunlik ketma-ketlik': [
    'Серия {streak} день',
    'Серия {streak} дня',
    'Серия {streak} дней',
  ],
  'Yangi oynada ochish': 'Открыть в новом окне',
  'Yorugʻ rejimga oʻtish': 'Включить светлую тему',
  'Qorongʻi rejimga oʻtish': 'Включить тёмную тему',
  'Yorugʻ rejim': 'Светлая тема',
  'Qorongʻi rejim': 'Тёмная тема',
  'Telegram maʼlumoti topilmadi. Ilovani bot orqali oching.':
    'Данные Telegram не найдены. Откройте приложение через бота.',
  'Ustoz tekshiradi': 'Проверяет преподаватель',
  'AI baholaydi': 'Оценивает AI',
  'Avtomat tekshiriladi': 'Проверяется автоматически',
  Topshiriq: 'Задание',
  'Alohida oynada ochish': 'Открыть в отдельном окне',
  'Qolgan urinishlar: {left} / {limit}': 'Осталось попыток: {left} / {limit}',
  'Ustoz sizga qoʻshimcha imkoniyat berdi: +{count}':
    'Преподаватель дал вам дополнительные попытки: +{count}',
  'Masalan: 1a2b3c': 'Например: 1a2b3c',
  'Yuklanmoqda {percent}%': 'Загрузка {percent}%',
  'Yuklanmoqda…': 'Загрузка…',
  'Matn yozilmagan': 'Без текста',
  'Ustoz tekshirmoqda.': 'Преподаватель проверяет.',
  'Baholandi: {score} ball': [
    'Оценено: {score} балл',
    'Оценено: {score} балла',
    'Оценено: {score} баллов',
  ],
  'Ochilmoqda…': 'Открываем…',
  'Qayta topshirish': 'Сдать заново',
  Kichraytirish: 'Уменьшить',
  Kattalashtirish: 'Увеличить',
  'Kichik oynaga': 'Свернуть',
  'Toʻliq ekran': 'На весь экран',
  'Brauzerda ochish': 'Открыть в браузере',
  'PDF yuklanmoqda…': 'Загрузка PDF…',
  'Faylni ochib boʻlmadi.': 'Не удалось открыть файл.',
  'Fayl — toʻliq ekran': 'Файл — на весь экран',
  Natija: 'Результат',
  'Kurs yakunlandi': 'Курс завершён',
  'Davom etmoqda': 'В процессе',
  'Sertifikatingiz profil boʻlimida.': 'Ваш сертификат — в разделе «Профиль».',
  'Keyingi dars uchun joriy nazorat testidan oʻting.':
    'Чтобы открыть следующий урок, пройдите текущий контрольный тест.',
  Takrorlash: 'Повторение',
  'Xulosa tayyorlanmoqda': 'Готовим сводку',
  'Savolingizni yozing': 'Напишите ваш вопрос',
  Kurs: 'Курс',
  Guruh: 'Группа',
  'Ustoz tasdiqlashini kutmoqda': 'Ожидает подтверждения преподавателя',
  'Yopilgan — ustozingizga murojaat qiling':
    'Закрыт — обратитесь к преподавателю',

  // ——— Kurs, reyting va dars sahifalari ———
  'Telegram orqali oching': 'Откройте через Telegram',
  'Bu ilova Telegram bot ichida ishlaydi. Botga qayting va {command} buyrugʻini yuboring.':
    'Это приложение работает внутри Telegram-бота. Вернитесь в бот и отправьте команду {command}.',
  'Maʼlumotlaringizni olishning iloji boʻlmadi. Internetni tekshirib qayta urinib koʻring.':
    'Не удалось получить ваши данные. Проверьте интернет и попробуйте снова.',
  'Soʻrovingiz ustozga yuborildi. Tasdiqlangach darslar shu yerda ochiladi.':
    'Ваш запрос отправлен преподавателю. После подтверждения уроки откроются здесь.',
  'Hisobingiz bloklangan': 'Ваш аккаунт заблокирован',
  'Oʻqish muddati tugagan yoki hisob toʻxtatilgan. Ustozingiz bilan bogʻlaning.':
    'Срок обучения истёк или аккаунт приостановлен. Свяжитесь с преподавателем.',
  'Botga qayting va {command} buyrugʻi orqali qaytadan kiring.':
    'Вернитесь в бот и войдите снова командой {command}.',
  'Tanga yetarli emas: {price} kerak, sizda {coins}.':
    'Недостаточно монет: нужно {price}, у вас {coins}.',
  'Tanga sarflansinmi?': 'Потратить монеты?',
  '{price} tanga evaziga muddati oʻtgan darsni ochish. Balansingiz: {coins}.': [
    'Открыть просроченный урок за {price} монету. Ваш баланс: {coins}.',
    'Открыть просроченный урок за {price} монеты. Ваш баланс: {coins}.',
    'Открыть просроченный урок за {price} монет. Ваш баланс: {coins}.',
  ],
  '{price} tanga evaziga darsni navbatsiz ochish. Balansingiz: {coins}.': [
    'Открыть урок вне очереди за {price} монету. Ваш баланс: {coins}.',
    'Открыть урок вне очереди за {price} монеты. Ваш баланс: {coins}.',
    'Открыть урок вне очереди за {price} монет. Ваш баланс: {coins}.',
  ],
  'Ha, ochish': 'Да, открыть',
  'Ochildi. Qolgan tanga: {coins}': 'Открыто. Осталось монет: {coins}',
  Kurslarim: 'Мои курсы',
  '{done} / {total} dars yakunlangan': 'Завершено уроков: {done} / {total}',
  'Shu kursda hozir: siz va yana {count} kishi': [
    'Сейчас на курсе: вы и ещё {count} человек',
    'Сейчас на курсе: вы и ещё {count} человека',
    'Сейчас на курсе: вы и ещё {count} человек',
  ],
  'Shu kursda hozir: faqat siz': 'Сейчас на курсе: только вы',
  '{count} ta dars qoldi': [
    'Остался {count} урок',
    'Осталось {count} урока',
    'Осталось {count} уроков',
  ],
  'Yakunlandi · {score} ball': [
    'Завершено · {score} балл',
    'Завершено · {score} балла',
    'Завершено · {score} баллов',
  ],
  '{count} ta savol': ['{count} вопрос', '{count} вопроса', '{count} вопросов'],
  Yopiq: 'Закрыт',
  'Guruh reytingi': 'Рейтинг группы',
  'Guruhni tanlang': 'Выберите группу',
  '{name} ({count} oʻquvchi)': [
    '{name} ({count} ученик)',
    '{name} ({count} ученика)',
    '{name} ({count} учеников)',
  ],
  '{rank}-oʻrin': '{rank}-е место',
  siz: 'вы',
  '{done} / {total} dars': 'Уроки: {done} / {total}',
  'Bu darsni hozir siz va yana {count} kishi koʻryapti': [
    'Сейчас этот урок смотрите вы и ещё {count} человек',
    'Сейчас этот урок смотрите вы и ещё {count} человека',
    'Сейчас этот урок смотрите вы и ещё {count} человек',
  ],
  'Koʻrildi: {watched}% / {required}%': 'Просмотрено: {watched}% / {required}%',
  'Shaxsiy qaydlar': 'Личные заметки',
  'Masalan: 05:23 — yangi formula': 'Например: 05:23 — новая формула',
  'Bu video Bunnyʼda, Bunny esa hozir ishlamayapti — oʻquvchilar uni koʻra olmaydi. Faylni qayta yuklang.':
    'Это видео хранится в Bunny, а Bunny сейчас не работает — ученики не могут его посмотреть. Загрузите файл заново.',
  'Video vaqtincha mavjud emas. Ustozingiz uni qayta yuklashi kerak — bu sizning internetingiz bilan bogʻliq emas.':
    'Видео временно недоступно. Преподавателю нужно загрузить его заново — это не связано с вашим интернетом.',
  'Testni ochish uchun videoni kamida {percent}% koʻring.':
    'Чтобы открыть тест, посмотрите не менее {percent}% видео.',
  'Bu darsning muddati oʻtgan. Qayta ochish uchun ustozingizga murojaat qiling.':
    'Срок этого урока истёк. Чтобы открыть его снова, обратитесь к преподавателю.',

  // ——— Profil va test ———
  'XP — bilim ballari': 'XP — баллы знаний',
  'Har bir darsni BIRINCHI marta yakunlaganingizda beriladi. Miqdori test natijangizga bogʻliq: 100% — toʻliq ball, 80% — uning 80 foizi. Darsni qayta ishlasangiz XP qayta berilmaydi. Guruh reytingi aynan XP boʻyicha tuziladi.':
    'Начисляется, когда вы завершаете урок в ПЕРВЫЙ раз. Количество зависит от результата теста: 100% — полный балл, 80% — 80% от него. При повторном прохождении урока XP не начисляется. Рейтинг группы строится именно по XP.',
  'Tanga — mukofot': 'Монеты — награда',
  'XP bilan bir vaqtda, uning beshdan bir qismi miqdorida beriladi. Yaʼni tanga toʻplash uchun darslarni yaxshi natija bilan yakunlash kerak.':
    'Начисляются вместе с XP — в размере пятой части от него. То есть, чтобы копить монеты, нужно завершать уроки с хорошим результатом.',
  'Kun — ketma-ketlik': 'Дни — серия',
  'Ketma-ket necha kun test topshirganingiz. Bir kunni oʻtkazib yuborsangiz hisob 1 ga qaytadi. Bu koʻrsatkich ballga taʼsir qilmaydi — u shunchaki qanchalik muntazam oʻqiyotganingizni koʻrsatadi.':
    'Сколько дней подряд вы сдаёте тесты. Если пропустить день, счёт вернётся к 1. Этот показатель не влияет на баллы — он просто показывает, насколько регулярно вы занимаетесь.',
  'qoʻshimcha test urinishi ({price})':
    'дополнительная попытка теста ({price})',
  'muddati oʻtgan darsni ochish ({price})':
    'открытие просроченного урока ({price})',
  'keyingi darsni navbatsiz ochish ({price})':
    'открытие следующего урока вне очереди ({price})',
  'Sertifikat Telegramga yuborildi.': 'Сертификат отправлен в Telegram.',
  'Sertifikatni yuborib boʻlmadi. Qaytadan urinib koʻring.':
    'Не удалось отправить сертификат. Попробуйте снова.',
  'Ustoz profili': 'Профиль преподавателя',
  'Siz oʻqituvchi rejimidasiz. Kurslar va guruhlarni boshqaruv panelidan boshqaring.':
    'Вы в режиме преподавателя. Управляйте курсами и группами в панели управления.',
  'Maʼlumotlar yuklanmadi': 'Данные не загрузились',
  'Internetni tekshirib, ilovani qaytadan oching.':
    'Проверьте интернет и откройте приложение заново.',
  'Bu kursda: 100% natija = {xp} XP va {coins} tanga.': [
    'В этом курсе: результат 100% = {xp} XP и {coins} монета.',
    'В этом курсе: результат 100% = {xp} XP и {coins} монеты.',
    'В этом курсе: результат 100% = {xp} XP и {coins} монет.',
  ],
  '80% = {xp} XP va {coins} tanga.': [
    '80% = {xp} XP и {coins} монета.',
    '80% = {xp} XP и {coins} монеты.',
    '80% = {xp} XP и {coins} монет.',
  ],
  'Bu kursda tangaga: {features}.':
    'В этом курсе монеты можно потратить на: {features}.',
  'Bu kursda tanga hozircha hech narsaga sarflanmaydi — u yutuqlaringiz belgisi.':
    'В этом курсе монеты пока ни на что не тратятся — это знак ваших достижений.',
  'Hali sertifikat yoʻq': 'Сертификатов пока нет',
  'Kursni toʻliq yakunlaganingizda sertifikat shu yerda paydo boʻladi.':
    'Когда вы полностью завершите курс, сертификат появится здесь.',
  Sertifikat: 'Сертификат',
  '{name} ushbu kursni muvaffaqiyatli yakunlagani uchun taqdim etiladi.':
    'Выдаётся ученику {name} за успешное завершение этого курса.',
  'Telegramga yuborish': 'Отправить в Telegram',
  'Bu darsning testidan muvaffaqiyatli oʻtgansiz va keyingi dars ochilgan.':
    'Вы успешно сдали тест этого урока, следующий урок открыт.',
  'Qayta ishlash': 'Пройти заново',
  'Qoʻshimcha urinish olinsinmi?': 'Взять дополнительную попытку?',
  '{price} tanga sarflanadi. Balansingiz: {coins}.': [
    'Будет списана {price} монета. Ваш баланс: {coins}.',
    'Будет списано {price} монеты. Ваш баланс: {coins}.',
    'Будет списано {price} монет. Ваш баланс: {coins}.',
  ],
  Olish: 'Взять',
  'Olindi. Qolgan tanga: {coins}': 'Готово. Осталось монет: {coins}',
  'Siz uchun berilgan imkoniyat': 'Выдано вам дополнительно',
  'Urinishlar tugagan. Qayta ochish uchun ustozingizga murojaat qiling.':
    'Попытки закончились. Чтобы открыть тест заново, обратитесь к преподавателю.',
  'Olinmoqda…': 'Покупка…',
  'Tanga yetarli emas ({price} kerak, sizda {coins})':
    'Недостаточно монет (нужно {price}, у вас {coins})',
  '{price} tangaga urinish olish': [
    'Купить попытку за {price} монету',
    'Купить попытку за {price} монеты',
    'Купить попытку за {price} монет',
  ],
  'Boshlanmoqda…': 'Запуск…',
  'Tahlilni olib boʻlmadi. Ustozingiz AI yordamchisini yoqmagan boʻlishi mumkin.':
    'Не удалось получить разбор. Возможно, преподаватель не включил AI-помощника.',
  Siz: 'Вы',
  'Tahlil…': 'Разбор…',
  'Nega xato?': 'Почему ошибка?',
  'Xatolar tahlil qilinmoqda': 'Разбираю ошибки',
  'Savol {current} / {total}': 'Вопрос {current} / {total}',
  'Javob variantlari': 'Варианты ответа',
  Oldingi: 'Назад',
  Keyingisi: 'Далее',
  'Tekshirilmoqda…': 'Проверка…',

  // ——— Ustoz rejimi (qoʻshimcha) ———
  '{count} oʻquvchi': ['{count} ученик', '{count} ученика', '{count} учеников'],
  '{count} ta diqqat talab': 'Требуют внимания: {count}',
  '{count} oʻquvchiga yuboriladi. Qaytarib boʻlmaydi.': [
    'Будет отправлено {count} ученику. Отменить нельзя.',
    'Будет отправлено {count} ученикам. Отменить нельзя.',
    'Будет отправлено {count} ученикам. Отменить нельзя.',
  ],
  Nomi: 'Название',
  Bepul: 'Бесплатно',
  'Bir marta': 'Разовая оплата',
  'Oyma-oy': 'Помесячно',
  'Oylik narx (soʻm)': 'Цена в месяц (сум)',
  'Narx (soʻm)': 'Цена (сум)',
  '0 — oʻchiq. Bu imkoniyat oʻquvchiga darsni umuman oʻqimasdan oʻtib ketishga ruxsat beradi, shuning uchun ataylab qoʻyilishi kerak.':
    '0 — выключено. Эта возможность позволяет ученику пропустить урок, вообще его не изучив, поэтому включайте её осознанно.',
  '0 — cheksiz. Aks holda oʻquvchi qoʻshilgandan shuncha kun oʻtib kirish yopiladi.':
    '0 — без ограничений. Иначе доступ закроется через столько дней после добавления ученика.',
  '0 — oʻchiq. Ikkalasi ham qoʻyilsa, bloklash ogohlantirishdan KEYIN boʻlishi kerak.':
    '0 — выключено. Если заданы оба, блокировка должна быть ПОСЛЕ предупреждения.',
  '{count} kun': ['{count} день', '{count} дня', '{count} дней'],
  'Fayl juda katta. Eng koʻpi {limit} MB.':
    'Файл слишком большой. Максимум {limit} МБ.',
  'Yuklash bekor qilindi.': 'Загрузка отменена.',
  '{label} — yuklashni bekor qilish': '{label} — отменить загрузку',
  '{label} — fayl yuklash': '{label} — загрузить файл',
  'Qayta ishlanmoqda — {percent}%. Darsni hozir saqlashingiz mumkin.':
    'Обработка — {percent}%. Урок уже можно сохранить.',
  Media: 'Медиа',
  Nazorat: 'Контроль',
  Qoidalar: 'Правила',
  'Videoni yuklang yoki YouTube havolasi.':
    'Загрузите видео или вставьте ссылку YouTube.',
  'Kamida necha foiz': 'Минимальный процент',
  Material: 'Материал',
  'PDF yoki hujjat.': 'PDF или документ.',
  'Topshiriq fayli': 'Файл задания',
  'Koʻp savolli test uchun: {example}. Bitta javob uchun matnni yozing; bir nechta toʻgʻri variant boʻlsa {separator} bilan ajrating. Katta-kichik harf, boʻshliq va apostrof turi hisobga olinmaydi.':
    'Для теста из нескольких вопросов: {example}. Для одного ответа напишите текст; если верных вариантов несколько, разделите их символом {separator}. Регистр, пробелы и вид апострофа не учитываются.',
  'AI shu javobga qarab baho beradi. Ixtiyoriy, lekin busiz baho ancha tasodifiy chiqadi.':
    'AI оценивает, ориентируясь на этот ответ. Необязательно, но без него оценка получается гораздо случайнее.',
  'Mazmuni toʻgʻri — 50 ball\nMisol keltirilgan — 30 ball\nSavodxonlik — 20 ball':
    'Верное содержание — 50 баллов\nПриведён пример — 30 баллов\nГрамотность — 20 баллов',
  'Test topshirilgandan keyin koʻrsatiladi — oʻtgan-oʻtmaganiga qaramay. Ixtiyoriy.':
    'Показывается после сдачи теста — независимо от результата. Необязательно.',
  '0 — cheksiz.': '0 — без ограничений.',
  '0 — cheklovsiz.': '0 — без ограничения.',
  'Muddat (kun)': 'Срок (дней)',
  '0 — muddatsiz.': '0 — бессрочно.',
  Baholangan: 'Оценённые',
  'Topshiriqni baholash': 'Оценка задания',
  '{amount} soʻm — qaytarib boʻlmaydi.': '{amount} сум — это нельзя отменить.',
  '{amount} soʻm': '{amount} сум',
  '{count} ball': ['{count} балл', '{count} балла', '{count} баллов'],
  'Uning butun progressi, ballari va toʻlovlari ham oʻchadi. Qaytarib boʻlmaydi.':
    'Весь его прогресс, баллы и платежи тоже удалятся. Это нельзя отменить.',
  '"{title}" uchun 1 ta urinish qoʻshiladi.\nOʻquvchiga Telegram orqali xabar yuboriladi.':
    'Для «{title}» будет добавлена 1 попытка.\nУченику придёт сообщение в Telegram.',
  Berish: 'Выдать',
  '{used} / {limit} urinish (+{extra} berilgan)':
    'Попытки: {used} / {limit} (+{extra} выдано)',
  '{used} / {limit} urinish': 'Попытки: {used} / {limit}',
  '+1 urinish berish': 'Дать +1 попытку',
  'Modul nomi': 'Название модуля',
  '{count} modul': ['{count} модуль', '{count} модуля', '{count} модулей'],
  '"{title}" kursi oʻchirilsinmi?': 'Удалить курс «{title}»?',
  '"{title}" moduli oʻchirilsinmi?': 'Удалить модуль «{title}»?',
  '"{title}" darsi oʻchirilsinmi?': 'Удалить урок «{title}»?',
  '{count} kun oldin': [
    '{count} день назад',
    '{count} дня назад',
    '{count} дней назад',
  ],
  'Ism yoki telefon': 'Имя или телефон',
  'Taklif havolasini yuboring.': 'Отправьте пригласительную ссылку.',
  'Boshqa saralashni tanlang.': 'Выберите другой фильтр.',
  qarzdor: 'должник',
  Tasdiqlash: 'Подтвердить',
  Bloklash: 'Заблокировать',
  '{count} ta savol qoʻshildi — tekshirib chiqing.': [
    'Добавлен {count} вопрос — проверьте его.',
    'Добавлено {count} вопроса — проверьте их.',
    'Добавлено {count} вопросов — проверьте их.',
  ],
  '{n}-savol matni boʻsh.': 'Текст вопроса {n} пуст.',
  '{n}-savolda kamida 2 ta variant boʻlsin.':
    'В вопросе {n} должно быть не меньше 2 вариантов.',
  '{n}-savolda toʻgʻri javob tanlanmagan.':
    'В вопросе {n} не выбран верный ответ.',
  '{n}-savol': 'Вопрос {n}',
  yangi: 'новый',
  '{n}-savolni oʻchirish': 'Удалить вопрос {n}',
  '{n}-savol matni': 'Текст вопроса {n}',
  'Savol matni': 'Текст вопроса',
  '{n}-savol variantlari': 'Варианты вопроса {n}',
  'Toʻgʻri javob': 'Верный ответ',
  '{letter} — toʻgʻri javob': '{letter} — верный ответ',
  '{letter} varianti': 'Вариант {letter}',
  'Vaqt chegarasi (daqiqa)': 'Ограничение времени (мин)',
  'Ball (0–100)': 'Балл (0–100)',
  'Summa (soʻm)': 'Сумма (сум)',
  'Guruh nomi': 'Название группы',
  Ustoz: 'Преподаватель',
  'Ustoz paneli': 'Панель преподавателя',

  // ——— Sinov imtihonlari (Rasch) ———
  Imtihon: 'Экзамен',
  Imtihonlar: 'Экзамены',
  'Sinov imtihonlari': 'Пробные экзамены',
  'Ustoz rejimi': 'Режим преподавателя',
  'Imtihonlarni boshqaruv panelida yarating va kuzating.':
    'Создавайте экзамены и следите за ними в панели управления.',
  'Imtihonlar yuklanmadi': 'Не удалось загрузить экзамены',
  'Hozircha imtihon yoʻq': 'Экзаменов пока нет',
  'Ustozingiz imtihon belgilaganda u shu yerda paydo boʻladi.':
    'Когда преподаватель назначит экзамен, он появится здесь.',
  Ochiq: 'Открыт',
  Yopildi: 'Закрыт',
  Baholandi: 'Оценён',
  'Boshlanadi: {date}': 'Начало: {date}',
  'Boshlanishiga {time} qoldi': 'До начала: {time}',
  'Topshirildi. Natija imtihon yopilgandan keyin eʼlon qilinadi.':
    'Сдано. Результат объявят после закрытия экзамена.',
  'Oyna yopilishiga {time} qoldi': 'До закрытия экзамена: {time}',
  'Oyna tez orada yopiladi — sizga toʻliq vaqt emas, {time} beriladi.':
    'Экзамен скоро закроется — у вас будет не полное время, а {time}.',
  'Davom ettirish': 'Продолжить',
  Boshlash: 'Начать',
  'Natija eʼlon qilinishi kutilmoqda': 'Ожидается объявление результатов',
  'Siz bu imtihonda qatnashmadingiz.': 'Вы не участвовали в этом экзамене.',
  'Daraja berilmaydi': 'Уровень не присваивается',
  'Daraja: {grade}': 'Уровень: {grade}',
  'Imtihon natijasi': 'Результат экзамена',
  'Natija yuklanmadi': 'Не удалось загрузить результат',
  'Imtihonlarga qaytish': 'Вернуться к экзаменам',
  'Sizning ballingiz': 'Ваш балл',
  'Ball Rasch modeli bilan hisoblangan. Bu imtihonda bir xil sondagi toʻgʻri javob bir xil ball beradi; savollar qanchalik qiyin boʻlsa, xuddi shu son shunchalik yuqori ballga aylanadi.':
    'Балл рассчитан по модели Раша. В этом экзамене одинаковое число правильных ответов даёт одинаковый балл; чем сложнее вопросы, тем выше балл за то же число.',
  'Savollar tahlili': 'Разбор вопросов',
  'Xatolar ({count})': 'Ошибки ({count})',
  'Xato yoʻq': 'Ошибок нет',
  'Barcha savollarga toʻgʻri javob bergansiz.':
    'Вы верно ответили на все вопросы.',
  'Javob berilmagan': 'Без ответа',
  'Javob berilgan': 'Отвечено',
  'Imtihon vaqti tugagan.': 'Время экзамена истекло.',
  'Javoblaringiz qabul qilindi. Natija imtihon yopilgandan keyin eʼlon qilinadi.':
    'Ваши ответы приняты. Результат объявят после закрытия экзамена.',
  'Topshirib boʻlmadi. Qaytadan urining.':
    'Не удалось сдать. Попробуйте ещё раз.',
  'Imtihonni ochib boʻlmadi': 'Не удалось открыть экзамен',
  '{count} ta savolga javob berilmagan: {list}.': [
    'Без ответа остался {count} вопрос: {list}.',
    'Без ответа остались {count} вопроса: {list}.',
    'Без ответа осталось {count} вопросов: {list}.',
  ],
  'Barcha savollarga javob berdingiz.': 'Вы ответили на все вопросы.',
  '{count} ta javob hali saqlanmagan — yana urinib koʻramiz.': [
    '{count} ответ ещё не сохранён — попробуем снова.',
    '{count} ответа ещё не сохранены — попробуем снова.',
    '{count} ответов ещё не сохранены — попробуем снова.',
  ],
  'Topshirgandan keyin javoblarni oʻzgartirib boʻlmaydi.':
    'После сдачи ответы изменить нельзя.',
  'Imtihonni topshirasizmi?': 'Сдать экзамен?',
  Topshirish: 'Сдать',
  'Topshirilmoqda…': 'Отправка…',
  '{n}-savol, saqlanmadi': 'Вопрос {n}, не сохранён',
  '{n}-savol, javob berilgan': 'Вопрос {n}, отвечен',
  '{n}-savol, javob berilmagan': 'Вопрос {n}, без ответа',
  'Javob berilgan: {done} / {total}': 'Отвечено: {done} / {total}',
  'Qolgan vaqt': 'Оставшееся время',
  '{count} ta saqlanmadi': [
    '{count} не сохранён',
    '{count} не сохранены',
    '{count} не сохранены',
  ],
  Saqlanmadi: 'Не сохранено',
  'Saqlanmadi — qayta urinish': 'Не сохранено — повторить',
  'Javobni tozalash': 'Сбросить ответ',
  '{count} soat': ['{count} час', '{count} часа', '{count} часов'],
  '{count} daqiqa': ['{count} минута', '{count} минуты', '{count} минут'],
  'Javobni yozing': 'Напишите ответ',
  'Sizning javobingiz:': 'Ваш ответ:',
  'Toʻgʻri javob:': 'Верный ответ:',
  Notoʻgʻri: 'Неверно',

  // ——— Imtihon: test kodi, qismlar, javoblar varaqasi ———
  'Milliy sertifikat formatidagi sinov, 75 ballik shkala. Ustoz bergan test kodini kiriting yoki roʻyxatdan tanlang.':
    'Пробный экзамен в формате Национального сертификата, шкала 75 баллов. Введите код теста от преподавателя или выберите экзамен из списка.',
  'Test kodi': 'Код теста',
  'Test kodi: {code}': 'Код теста: {code}',
  'Test kodini kiriting.': 'Введите код теста.',
  'Kod 3–20 ta lotin harfi, raqam yoki chiziqchadan iborat.':
    'Код состоит из 3–20 латинских букв, цифр или дефисов.',
  'Bunday kodli test topilmadi': 'Тест с таким кодом не найден',
  'Masalan: TEST10': 'Например: TEST10',
  'Qidirilmoqda…': 'Поиск…',
  'Topilgan test': 'Найденный тест',
  Topshirildi: 'Сдано',
  Tekshirilmoqda: 'На проверке',
  'Yozma ish tekshirilmoqda': 'Письменная работа на проверке',
  'Sertifikat berilmaydi': 'Сертификат не выдаётся',
  'Topshirildi. Yozma ishlar tekshirilmoqda — natija keyin eʼlon qilinadi.':
    'Сдано. Письменные работы проверяются — результат объявят позже.',
  'Imtihon topshirildi': 'Экзамен сдан',
  'Javoblaringiz qabul qilindi.': 'Ваши ответы приняты.',
  'Vaqt tugadi. Javoblaringiz saqlandi.': 'Время вышло. Ваши ответы сохранены.',
  'Keyingi qismni boshlab boʻlmadi.': 'Не удалось начать следующую часть.',
  '{title} topshirildi': '{title}: сдано',
  'Qism topshirildi': 'Часть сдана',
  Navbatda: 'Следующая',
  Keyin: 'Позже',
  'Keyingi qism': 'Следующая часть',
  'Keyingi qism vaqti siz uni boshlaganingizda yura boshlaydi.':
    'Время следующей части пойдёт, когда вы её начнёте.',
  '{title}ni boshlash': 'Начать: {title}',
  'Keyinroq davom ettirish': 'Продолжить позже',
  'Bu qismda savol yoʻq': 'В этой части нет вопросов',
  'Qismni topshirish': 'Сдать часть',
  'Saqlash va topshirish': 'Сохранить и сдать',
  'Fayl yuklanishini kuting.': 'Дождитесь загрузки файла.',
  'Keyingi qismga oʻtgach, bu qismga qaytib boʻlmaydi.':
    'После перехода к следующей части вернуться к этой будет нельзя.',
  '{title}ni topshirasizmi?': 'Сдать {title}?',
  Saqlandi: 'Сохранено',
  'Savollar (PDF)': 'Вопросы (PDF)',
  '{current} / {total} qism': 'Часть {current} из {total}',
  'Javoblar varaqasi': 'Бланк ответов',
  '{n}-savol saqlanmadi — qayta urinish': 'Вопрос {n} не сохранён — повторить',
  Javob: 'Ответ',
  '{n}-savol javobi': 'Ответ на вопрос {n}',
  'Yozma javob — bandlarga boʻlib yozing': 'Письменный ответ — по пунктам',
  'Yozma ish — ustoz tekshiradi': 'Письменная работа — проверит преподаватель',
  'Javobni bandlarga boʻlib yozing: a), b), c)…':
    'Запишите ответ по пунктам: a), b), c)…',
  '{n}-savol, {band}) band': 'Вопрос {n}, пункт {band})',
  '{n}-savol: oxirgi bandni olib tashlash':
    'Вопрос {n}: удалить последний пункт',
  '{n}-savol: band qoʻshish': 'Вопрос {n}: добавить пункт',
  '{n}-faylni ochish': 'Открыть файл {n}',
  '{n}-faylni olib tashlash': 'Удалить файл {n}',
  'Biriktirilgan fayl': 'Прикреплённый файл',
  'Faqat rasm (JPG, PNG, WEBP) yoki PDF yuklash mumkin.':
    'Можно загрузить только изображение (JPG, PNG, WEBP) или PDF.',
  'Eng koʻpi {count} ta fayl biriktirish mumkin.': [
    'Можно прикрепить не больше {count} файла.',
    'Можно прикрепить не больше {count} файлов.',
    'Можно прикрепить не больше {count} файлов.',
  ],
  'Fayl yuklanmadi — aloqa uzildi. Internetni tekshirib qayta urining.':
    'Файл не загружен — связь прервалась. Проверьте интернет и попробуйте снова.',
  'Yechimni yozing yoki rasmga olib biriktiring':
    'Напишите решение или сфотографируйте и прикрепите',
  '{n}-savol yechimi': 'Решение вопроса {n}',
  'Rasmga olish': 'Сфотографировать',
  'Fayl biriktirish': 'Прикрепить файл',
  Galereya: 'Галерея',
  'navbatda {count} ta': 'в очереди {count}',
  'Rasm yoki PDF, har biri 20 MB gacha.':
    'Изображение или PDF, каждый до 20 МБ.',
  Qisman: 'Частично',
  Javobsiz: 'Без ответа',
  Jami: 'Всего',
  'Yozma ish tekshirilmoqda — yakuniy ball keyin chiqadi.':
    'Письменная работа на проверке — итоговый балл появится позже.',
  'Har savol bali qiyinligiga qarab: oson, oʻrta va qiyin savollar 1,3 : 1,7 : 2,2 nisbatda. Yakuniy ball — qismlar ballining oʻrtachasi.':
    'Балл за вопрос зависит от сложности: лёгкие, средние и сложные — в соотношении 1,3 : 1,7 : 2,2. Итоговый балл — среднее по частям.',
  'Har savol bali qiyinligiga qarab: oson, oʻrta va qiyin savollar 1,3 : 1,7 : 2,2 nisbatda.':
    'Балл за вопрос зависит от сложности: лёгкие, средние и сложные — в соотношении 1,3 : 1,7 : 2,2.',
  'Toʻgʻri javoblar imtihon yopilgach koʻrinadi.':
    'Правильные ответы будут видны после закрытия экзамена.',
  '{n}-savol: {outcome}': 'Вопрос {n}: {outcome}',
  'Tafsilotni koʻrish uchun raqamni bosing.':
    'Нажмите на номер, чтобы увидеть подробности.',
  '{points} ball': '{points} б.',
  'Ustoz tekshirgach ball shu yerda chiqadi.':
    'Балл появится здесь после проверки преподавателем.',
  'Ustoz izohi:': 'Комментарий преподавателя:',
  Band: 'Пункт',
  'Sizning javobingiz': 'Ваш ответ',
  'Variantli savol': 'Вопрос с вариантами',
  'Ochiq javob': 'Открытый ответ',
  'Yozma javob (bandlar)': 'Письменный ответ (по пунктам)',
  'Yozma ish': 'Письменная работа',
  'Kanalga aʼzo boʻling': 'Подпишитесь на канал',
  '«{course}» kursi darslarini ochish uchun ustozingiz kanalga aʼzo boʻlishni soʻragan.':
    'Чтобы открыть уроки курса «{course}», преподаватель просит подписаться на канал.',
  'Kanalga oʻtish': 'Перейти в канал',
  'Aʼzo boʻldim — tekshirish': 'Я подписался — проверить',
  'Hali aʼzo emassiz. Kanalga qoʻshilib, qayta tekshiring.':
    'Вы ещё не подписаны. Подпишитесь на канал и проверьте снова.',
  'Boshqa kursni tanlash': 'Выбрать другой курс',
  'Saytdan chiqish': 'Выйти с сайта',
  'Saytdan chiqasizmi?': 'Выйти с сайта?',
  'Qayta kirish uchun Telegram orqali yana kirasiz.':
    'Чтобы вернуться, снова войдите через Telegram.',
  Chiqish: 'Выйти',
  '1-urinish: {count} ball': [
    '1-я попытка: {count} балл',
    '1-я попытка: {count} балла',
    '1-я попытка: {count} баллов',
  ],
  'video {watched}%': 'видео {watched}%',
  'Keyingi urinish {time} da ochiladi.': 'Следующая попытка откроется в {time}.',
  'Tahlil videosini oxirigacha koʻrsangiz — darhol ochiladi.':
    'Посмотрите видеоразбор до конца — и она откроется сразу.',
  'Endi qayta topshirishingiz mumkin.': 'Теперь можно пересдать.',
  'Qayta topshirishdan oldin kutish, soat': 'Ожидание перед пересдачей, часов',
  'Avtomatik tekshiriladigan test yiqilsa. Tahlil videosini koʻrgan oʻquvchi kutmaydi. 0 — kutishsiz':
    'Если автоматически проверяемый тест не сдан. Посмотревший видеоразбор не ждёт. 0 — без ожидания',
  'XP birinchi urinish natijasidan beriladi.':
    'XP начисляется по результату первой попытки.',
  'AI bahosi: {count} ball': [
    'Оценка ИИ: {count} балл',
    'Оценка ИИ: {count} балла',
    'Оценка ИИ: {count} баллов',
  ],
  'AI javobni oʻqiy olmadi — ishni siz baholang.':
    'ИИ не смог прочитать ответ — оцените работу сами.',
  'AI qanday baholadi': 'Как оценил ИИ',
  'Bahoni oʻzgartirish (0–100)': 'Изменить оценку (0–100)',
  'Matn yozilmagan, ilova esa rasm yoki PDF emas.':
    'Текст не написан, а вложение — не изображение и не PDF.',
  'Mulohaza (ustoz uchun)': 'Обоснование (для преподавателя)',
  'Oʻquvchiga koʻrsatilgan izoh': 'Комментарий, показанный ученику',
  'Siz bahoni {teacher} ga oʻzgartirgansiz (AI: {ai}).':
    'Вы изменили оценку на {teacher} (ИИ: {ai}).',
  'faqat yozilgan matnni koʻrdi': 'видел только написанный текст',
  'rasm/PDF ilovani ham koʻrdi': 'видел и вложение (изображение/PDF)',
  Avto: 'Авто',
  AI: 'ИИ',
  '"{title}" darsi yana topshirish uchun ochiladi.\nOʻquvchiga Telegram orqali xabar yuboriladi.':
    'Урок «{title}» снова откроется для сдачи.\nУченик получит сообщение в Telegram.',
  'Bugun tugaydi': 'Заканчивается сегодня',
  'Dars muddati oʻtgach, yopilishidan oldin. 0 — darhol':
    'После срока урока, до его закрытия. 0 — сразу',
  'Dars qayta ochildi.': 'Урок снова открыт.',
  'Dars qayta ochilsinmi?': 'Открыть урок снова?',
  'Ertaga tugaydi': 'Заканчивается завтра',
  'Kechikishga imtiyoz, kun': 'Отсрочка после срока, дней',
  'Qayta ochish': 'Открыть снова',
  'Reja: {date} gacha': 'План: до {date}',
  '{count} kun qoldi': [
    'Остался {count} день',
    'Осталось {count} дня',
    'Осталось {count} дней',
  ],
  '{date} gacha': 'до {date}',
};
